import { TextStyleFormattingConvertersFactory } from '@tableau/css-fonts-fallback';
import * as React from 'react';
import { ButtonZoneTextStyle } from '../styles/ButtonZoneTextStyle';

export const FontStyle_Italic = 'italic';
export const FontStyle_Normal = 'normal';

export const FontWeight_Bold = 'bold';
export const FontWeight_Normal = 'normal';

export const TextDecorationLine_Underline = 'underline';
export const TextDecorationLine_None = 'none';

export const GrayscaleColor = '#FFFFFF';

export const ButtonZoneTextContentTestId = 'tab-button-zone-text';

export interface ButtonZoneTextProps {
  readonly buttonTextIsEnabled: boolean;
  readonly effectiveCaption: string;
  readonly captionTextFont: string;
  readonly captionTextColor: string;
  readonly captionFontSize: number;
  readonly captionFontIsBold: boolean;
  readonly captionFontIsItalic: boolean;
  readonly captionFontIsUnderlined: boolean;
  handleFontLoaded: () => void;
}

export class ButtonZoneTextComponent extends React.PureComponent<ButtonZoneTextProps> {
  public constructor(props: ButtonZoneTextProps) {
    super(props);
  }

  public render(): JSX.Element {
    const buttonTextCSSProperties = this.createButtonTextCSSProperties();
    const buttonTextClassName = this.props.buttonTextIsEnabled
      ? ButtonZoneTextStyle.tabButtonZoneText
      : ButtonZoneTextStyle.tabButtonZoneTextDisabled;

    return (
      <div className={buttonTextClassName} style={buttonTextCSSProperties} data-testid={ButtonZoneTextContentTestId}>
        {this.props.effectiveCaption}
      </div>
    );
  }

  private createButtonTextCSSProperties(): React.CSSProperties {
    const cssProperties: React.CSSProperties = {
      fontFamily: this.props.captionTextFont,
      color: this.props.buttonTextIsEnabled ? this.props.captionTextColor : GrayscaleColor,
      fontSize: this.props.captionFontSize.toString() + 'pt',
      fontStyle: this.props.captionFontIsItalic ? FontStyle_Italic : FontStyle_Normal,
      fontWeight: this.props.captionFontIsBold ? FontWeight_Bold : FontWeight_Normal,
      textDecorationLine: this.props.captionFontIsUnderlined ? TextDecorationLine_Underline : TextDecorationLine_None,
    };

    TextStyleFormattingConvertersFactory.cleanUpFontFamilyStylingForCSSProperties(cssProperties);
    return cssProperties;
  }
}
